import React from 'react';
import EnterAmountDF from '../components/SimulatorsComponents/DefualtSimulators/EnterAmountDF';
import { getSubCategoryId } from '../utils/DictionaryManagementUtils';

//= ========================================================================
const Sim_B08_SendMoneyEnterAmount = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => (
  <EnterAmountDF
    globJSON={globJSON}
    selectedScreen={selectedScreen}
    simPlatform={simPlatform}
    slideshowRefs={slideshowRefs}
    amount={globJSON.configurations.services[getSubCategoryId(globJSON.screens[selectedScreen])].amount}
  />
);

export default Sim_B08_SendMoneyEnterAmount;
